import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimeoutError } from 'rxjs';

import { AppError } from './app-error.model';
import { DEFAULT_ERROR_MESSAGES } from './error-message.constants';
import { mapHttpError } from './http-error.mapper';
import { mapOktaError } from './okta-error.mapper';

@Injectable({ providedIn: 'root' })
export class ErrorMapperService {
    toAppError(error: unknown, context?: 'login' | 'otp' | 'recovery' | 'reset'): AppError {
        if (this.isAppError(error)) {
            return error;
        }

        if (error instanceof HttpErrorResponse || error instanceof TimeoutError || this.isTimeoutLike(error)) {
            return mapHttpError(error as HttpErrorResponse | TimeoutError);
        }

        if (context) {
            return mapOktaError(error, context);
        }

        return {
            type: 'unknown',
            title: DEFAULT_ERROR_MESSAGES.unknown.title,
            message: DEFAULT_ERROR_MESSAGES.unknown.message,
            retryable: DEFAULT_ERROR_MESSAGES.unknown.retryable
        };
    }

    private isAppError(error: unknown): error is AppError {
        if (!error || typeof error !== 'object') {
            return false;
        }

        const candidate = error as Partial<AppError>;
        return typeof candidate.type === 'string' && typeof candidate.message === 'string';
    }

    private isTimeoutLike(error: unknown): boolean {
        return !!error && typeof error === 'object' && (error as { name?: string }).name === 'TimeoutError';
    }
}
